@if (loading) {
    <spinner-overlay [fullscreen]="true"></spinner-overlay>
}

<app-menu [helpGuides]="helpGuides" (menuEvent)="handleFunctionEvent($event)" [screen]="screen"></app-menu>

<div class="organisation-container">
    <mat-card appearance="outlined">
        <mat-card-content>
            <div class="page-header">
                <div>
                    <h2>Organisations</h2>
                    <p class="page-description">
                        @if (loaded) {
                            {{organisations.length}}{{isFiltered() ? ' of ' + allOrganisations.length : ''}} organisation{{allOrganisations.length === 1 ? '' : 's'}}{{isSysAdmin ? '' : ' you belong to'}}. Select one to open it.
                        }
                    </p>
                </div>
                <div class="header-actions">
                    @if (isSysAdmin) {
                        <button mat-stroked-button color="accent" (click)="exportAdministrators()"><mat-icon>download</mat-icon>Export administrators</button>
                        <button mat-stroked-button color="accent" matTooltip="Make a new organisation from an organisation export file" (click)="importOrganisation()" data-testid="import-organisation"><mat-icon>upload_file</mat-icon>Import organisation</button>
                    }
                    <button mat-flat-button color="accent" (click)="newOrganisation()"><mat-icon>add</mat-icon>Create organisation</button>
                </div>
            </div>

            @if (isSysAdmin) {
                <div class="filters">
                    <mat-form-field>
                        <mat-label>Partner</mat-label>
                        <mat-select [(ngModel)]="isPartner" (selectionChange)="filterChange()">
                            @for (v of possibleValues; track v) {
                                <mat-option [value]="v">{{v}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Customer</mat-label>
                        <mat-select [(ngModel)]="isCustomer" (selectionChange)="filterChange()">
                            @for (v of possibleValues; track v) {
                                <mat-option [value]="v">{{v}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Consumption pricing</mat-label>
                        <mat-select [(ngModel)]="consumption" (selectionChange)="filterChange()">
                            @for (v of possibleValues; track v) {
                                <mat-option [value]="v">{{v}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (isFiltered()) {
                        <button mat-button color="accent" (click)="clearFilters()">Clear filters</button>
                    }
                </div>
            }

            @if (loaded) {
                <app-organisations [organisations]="organisations" (changed)="loadOrganisations()"></app-organisations>
            }
        </mat-card-content>
    </mat-card>
</div>
